import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const getDevRevAccessToken = createModule({
  base: 'GET_DEVREV_ACCESS_TOKEN',
  apiDetails: SERVICE_ENDPOINT.GET_DEVREV_ACCESS_TOKEN,
  errors: { defaultError: false, customError: '' },
  customHandler: {
    finally: (action) => {
      action.payload.isFetchingDevRevTokenRef.current = false;
    },
  },
});
export { getDevRevAccessToken };
